import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Observable, of, OperatorFunction, switchMap, tap, catchError } from 'rxjs';
import { CompoundService } from 'src/app/_services/compound.service';
import { HammaddeService } from 'src/app/_services/hammadde.service';
import { PropertyService } from 'src/app/_services/property.service';

@Component({
  selector: 'app-addcompound',
  templateUrl: './addcompound.component.html',
  styleUrls: ['./addcompound.component.css']
})
export class AddcompoundComponent implements OnInit {

submitted=false;
  definitionForm:FormGroup;
  hammeddeler:any[]=[];
  selectedHammaddeler:any[]=[];
  properties:any[]=[];
  @Input() hammadde:any;

  madde:any;
  hm:any;
  bu:any;

  constructor(
    private formBuilder:FormBuilder,
    private compoundService:CompoundService,
    private toastr: ToastrService,
    private hammaddeServce:HammaddeService,
    private propertyService:PropertyService
    
  ) { }

  ngOnInit() {

   //this.getHammaddeler();
    this.definitionForm=this.formBuilder.group({
      'name':['',Validators.required],
      'properties':this.formBuilder.array([]),
      'pureness':this.formBuilder.array([]),
     
    });
    this.getProperties();

   this.addPure();
  }

  getProperties(){
    this.propertyService.getHammaddeler().subscribe(res=>{
      this.properties=res;
      this.properties.forEach((element)=>{
        console.log(element.name);
       this. addProjectDutyPerson(element.name)
      })
    });

  }


  getProjectDutyPerson() {
    return this.definitionForm.get("properties") as FormArray;
  }

  addProjectDutyPerson(name:any) {
    this.getProjectDutyPerson().push(this.createProjectDutyPerson(name));
  }

  createProjectDutyPerson(name:any): FormGroup {
    return this.formBuilder.group({
      property: [name],
      value: [""],
     method:[""]
    });
  }
  
  removeDuty(i) {
    this.getProjectDutyPerson().removeAt(i);
  }


  
  getPure() {
    return this.definitionForm.get("pureness") as FormArray;
  }

  addPure() {
    this.getPure().push(this.createPure());
  }

  createPure(): FormGroup {
    return this.formBuilder.group({
      name: [''],
      limit: [""],
      spesification:[""]
    });
  }
  
  removePure(i) {
    this.getPure().removeAt(i);
  }

  close(){

  }


  save(){


    if(this.selectedHammaddeler.length==0){
       this.toastr.error('', 'Lütfen hammadde ekleyin.');
      return;
    }
    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
     
      return;
    }
    this.submitted=true;

     var maddeler=[];
      for(var i=0;i<this.selectedHammaddeler.length;i++){
        maddeler.push({materialId:this.selectedHammaddeler[i].material.id,hm:this.selectedHammaddeler[i].hm,bu:this.selectedHammaddeler[i].bu})
      }

    var model={
      name:this.definitionForm.get("name").value,
      materials: maddeler,
      properties:this.definitionForm.get("properties").value,
      pureness:this.definitionForm.get("pureness").value,
    };

    console.log(model);

    if(this.hammadde){
      //update
      const updatedModel = { ...model, id: this.hammadde.id };
      this.compoundService.editCompounds(updatedModel,this.hammadde.id).subscribe(res=>{
        this.submitted=false;
        this.toastr.clear();
        this.toastr.success('', 'Kayıt güncelleme başarılı');
        this.definitionForm.reset();
        this.selectedHammaddeler=[];
       
      },err=>{
        this.toastr.error('', 'Kayıt güncelleme sırasında hata oluştu');
        this.submitted=false;
      });
    }
    else{
      //insert
      this.compoundService.addCompounds(model).subscribe(res=>{
        this.submitted=false;
        this.toastr.clear();
        this.toastr.success('', 'Kayıt başarılı');
        this.definitionForm.reset();
    
      },err=>{
        this.toastr.error('', 'Kayıt sırasında hata oluştu');
        this.submitted=false;
      });
    }
  
  }


  addHammadde(){

    if(this.madde==null){
       this.toastr.error('hata', 'Lütfen hammadde seçiniz.');
    }

    if(this.hm==null){
       this.toastr.error('hata', 'Hm alanı boş olamaz');
    }
   
    if(this.selectedHammaddeler.some((x)=>x.material.inciName==this.madde.inciName))

      {
    this.toastr.error('hata', 'Bu hammadde zaten ekli.');
    return;
   }

   this. selectedHammaddeler.push({material:this.madde,hm:this.hm,bu:this.bu,materialId:this.madde.id});
  
   this.madde=null;
   this.hm=null;
   this.bu=null;
   
  }
  removemadde(i){
    this.selectedHammaddeler.splice(i, 1)
  }

	searching = false;
	searchFailed = false;


  search: OperatorFunction<string, any[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => (this.searching = true)),
			switchMap((term) =>
				this.hammaddeServce.search(term,1).pipe(
					tap(() => (this.searchFailed = false)),
					catchError(() => {
						this.searchFailed = true;
						return of([]);
					}),
				),
			),
			tap(() => (this.searching = false)),
		);


    formatter = (x: { inciName: string }) => x.inciName;
  
}
